export default {
  title01: "Trenutačno vrijeme",
  title02: "24 sata",
  title03: "Pogledaj prognozu za 10 dana",
  title04: "AQI",
  title05: "Pogledaj sve informacije",
  title06: "IZLAZAK I ZALAZAK SUNCA",
  title07: "FAZA MJESECA",
  title08: "Sljedeći pun mjesec",
  title09: "Sljedeći mladi mjesec",
  title10: "DAN",
  title11: "NOĆ",
  title12: "Izlazak sunca",
  title13: "Zalazak sunca",
  title14: "Izlazak mjeseca",
  title15: "Zalazak mjeseca",
  title16: "Izvor",
  title17: "Početak",
  title18: "Kraj",
  title19: "Koristi trenutnu lokaciju",
  title20: "Pretraži grad",
  title21: "Osjećaj temperature",
  title22: "Osjećaj u hladu",
  title23: "Sada",
  title24: "Danas",
  title25: "Nedjelja",
  title26: "Ponedjeljak",
  title27: "Utorak",
  title28: "Srijeda",
  title29: "Četvrtak",
  title30: "Petak",
  title31: "Subota",
  title32: "Učitavanje...",
  title33: "Sada",
  title34: "Sati po satu",
  title35: "Dnevno",
  title36: "Sunce i Mjesec",
  title37: "Kvaliteta zraka",
  title38: "Kontakt: xlf550402@gmail.com",
  title39: "Pravila privatnosti",
  title40: "Autorska prava © comfortweather.com 2020 - 2026. Sva prava pridržana.",
  title41: "Podaci pruženi od [LOGO]",
  title42: "Najviša temperatura",
  title43: "Najniža temperatura",
  title44: "Prihvati",
  title45:
    "Hvala što koristite ComfortWeather! Za bolju zaštitu vaših pravnih prava i interesa, molimo vas da pažljivo pročitate ",
  title46: "„Politiku privatnosti“",
  title47: " prije korištenja.",
  title48: "",
  title49: "Kontakt: xyjph123@gmail.com",
  title50: "Autorska prava © 24hweather.com 2020 - 2026. Sva prava pridržana.",
  title51: "Hvala što koristite 24hweather! Za bolju zaštitu vaših pravnih prava i interesa, molimo vas da pročitate",
  title52: "Vaša lokacija se promijenila. Želite li je ažurirati?",
  title53: "Potvrdi",
  title54: "Otkaži",
  title55: "Natrag",
  title56: "Novosti",
  title57: "Ažuriranje vremena...",
  title58: "Vrijeme ažurirano",
  title59: "Prikaži sve",
  title60: "Autorska prava © mobi321.com 2020 - 2026. Sva prava pridržana.",
  title61: "Jučer",
  title62: "Sutra",
  title63: "Prognoza za 15 dana",
  title64: "Detalji za danas",
  title65: "Rahu Kaal",
  title66: "Indeksi životnog stila",
  title67: "Indeksi životnog stila",
  title68: "Rahu Kaal vremena za sljedećih 7 dana",
  title69: "Do",
  title70: "do",
  title71: "Indeks kvalitete zraka",

  title102: "Teško se suši",
  title103: "Sporo sušenje",
  title104: "Dobro se suši",
  title105: "Brzo sušenje",
  title106: "Vrlo brzo sušenje",

  title107: "Nije prikladno",
  title108: "Osrednje iskustvo",
  title109: "Dobro za vodene aktivnosti",
  title110: "Vrlo prikladno",
  title111: "Savršeni uvjeti",

  title112: "Uvjeti povoljni za zdravlje",
  title113: "Neutralni uvjeti",
  title114: "Nešto veći rizik",
  title115: "Visok rizik",
  title116: "Vrlo visok rizik",

  title117: "Nije prikladno",
  title118: "Djelomično prikladno",
  title119: "Dobro za boravak na otvorenom",
  title120: "Vrlo prikladno",
  title121: "Izvrsni uvjeti",

  title122: "Vrlo suhi uvjeti",
  title123: "Vjerojatna suhoća",
  title124: "Blaga suhoća",
  title125: "Malo je vjerojatna suhoća",
  title126: "Vrlo malo je vjerojatna suhoća",

  title127: "Ne preporučuje se",
  title128: "Prihvatljivo",
  title129: "Dobar dan",
  title130: "Vrlo dobri uvjeti",
  title131: "Idealni uvjeti",
};
